const actions = {};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/white-label/actions.js